import ReactDOM from "react-dom/client";
import Planificador from "./App.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(<Planificador />);
